<template>
  <div class="loading-screen" v-if="isLoading == true">
    <h2>Loading in Project</h2>
    <div class="spinner-wrap">
      <md-progress-spinner :md-diameter="100" :md-stroke="10" md-mode="indeterminate"
        class="md-accent"></md-progress-spinner>
    </div>
  </div>

  <div class="md-layout project-page" v-else>
    <div class="loading-screen" v-if="notAllowed == true">
      <h2>Not Allowed</h2>
      <!-- <div class="spinner-wrap">
        <md-progress-spinner :md-diameter="100" :md-stroke="10" md-mode="indeterminate" class="md-accent"></md-progress-spinner>
      </div> -->
      <div class="not-allowed">
        <h4>You are not allowed to access this project. Please contact the person you got this link from to make sure
          you have been added to this project.</h4>
        <router-link :to="{ name: 'Project Portal'}">
          <md-button class="md-primary">Return to Project Portal</md-button>
        </router-link>
      </div>
    </div>
    <div v-if="notAllowed == false"
      class="md-layout-item md-size-90 md-small-size-100 md-xsmall-size-100 md-medium-size-100 md-alignment-top-left">
      <md-card>
        <md-card-header>
          <div class="gpr-info">
            <div class="top-row">
              <h5>Project: {{project.project.name}}</h5> <small>Requested On: {{project.ats_data.created_at |
                formatDate}}</small>
            </div>
          </div>
          <StatusProgress v-bind:project_statuses.sync="project.project_statuses"
            v-bind:projectId="project.project.id" />
        </md-card-header>
        <md-card-content>
          <tabs2
            :tab-name="['Project Info', 'Comments', 'Photos/Drawings/Files', 'Project Members', 'Maintenance Logs', 'Locations', 'Terms and Conditions']"
            :mobile-names="['Project Info/Back', 'Add/View Comments', 'Add/View Photos/Drawings/Files', 'Add/View Project Members', 'Add/View Maintenance Logs', 'Locations', 'Terms and Conditions']"
            :activeTab="'Project Info'" :linkTab="{ 'Access/View GPR Report': `/gprreportview/${project.project.id}` }"
            v-if="project.gpr_report.data === null">
            <template slot="tab-pane-1">
              <InfoTab v-bind:project="project" />
            </template>

            <template slot="tab-pane-2">
              <CommentsTab v-bind:project='project' v-on:deleteComment="deleteCommentFromProject" />
            </template>
            <template slot="tab-pane-3">
              <FilesTab v-bind:project='project' />
            </template>
            <template slot="tab-pane-4">
              <PeopleTab v-bind:users="project.users" v-bind:projectId="project.project.id" />
            </template>
            <template slot="tab-pane-5">
              <MaintenanceLogTab v-bind:project="project" />
            </template>

            <template slot="tab-pane-6">
              <LocationsTab v-bind:ats_data="project.ats_data" v-bind:locations="project.locations"
                v-bind:projectId="project.project.id" v-bind:gpr_report="project.gpr_report" />
            </template>

            <template slot="tab-pane-7">
              <Signature v-bind:request="request" v-bind:goBack="false" v-bind:projectId="project.project.id"
                v-on:goSign="goSignature" />
            </template>

          </tabs2>

          <tabs2
            :tab-name="['Access/View GPR Report', 'Project Info', 'Comments', 'Photos/Drawings/Files', 'Project Members', 'Maintenance Logs', 'Locations', 'Terms and Conditions']"
            :mobile-names="['Access/View GPR Report', 'Project Info/Back', 'Add/View Comments', 'Add/View Photos/Drawings/Files', 'Add/View Project Members', 'Add/View Maintenance Logs', 'Locations', 'Terms and Conditions']"
            :activeTab="'Project Info'" :linkTab="{ 'Access/View GPR Report': `/gprreportview/${project.project.id}` }"
            v-else>
            <template slot="tab-pane-2">
              <InfoTab v-bind:project="project" />
            </template>

            <template slot="tab-pane-3">
              <CommentsTab v-bind:project='project' v-on:deleteComment="deleteCommentFromProject" />
            </template>
            <template slot="tab-pane-4">
              <FilesTab v-bind:project='project' />
            </template>
            <template slot="tab-pane-5">
              <PeopleTab v-bind:users="project.users" v-bind:projectId="project.project.id" />
            </template>
            <template slot="tab-pane-6">
              <MaintenanceLogTab v-bind:project="project" />
            </template>

            <template slot="tab-pane-7">
              <LocationsTab v-bind:ats_data="project.ats_data" v-bind:locations="project.locations"
                v-bind:projectId="project.project.id" v-bind:gpr_report="project.gpr_report" />
            </template>

            <template slot="tab-pane-8">
              <Signature v-bind:request="request" v-bind:goBack="false" v-bind:projectId="project.project.id"
                v-on:goSign="goSignature" />
            </template>

          </tabs2>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>

  import {
    InfoTab,
    CommentsTab,
    FilesTab,
    PeopleTab,
    MaintenanceLogTab
  } from "@/pages/Dashboard/ProjectPages/Components";
  import {StatusProgress} from "@/pages/Dashboard/ProjectPages/Components/StatusProgress";
  import {LocationsTab} from "@/pages/Dashboard/ProjectPages/Components/LocationsTab";
  import api from "@/api";
  import moment from 'moment';
  import { Tabs2 } from "@/components";
  import idx from 'idx';
  import Signature from "@/pages/Dashboard/ProjectPages/Components/Signature.vue";

  export default {
    components: {
      InfoTab,
      LocationsTab,
      CommentsTab,
      FilesTab,
      PeopleTab,
      MaintenanceLogTab,
      StatusProgress,
      Tabs2,
      Signature
    },
    data() {
      return {
        request: {
          terms: false,
          signed_company_name: '',
          signed_user_name: '',
          customer_signature: '',
          gpr_techinician: ''
        },
        currentTab: 'locations',
        isLoading: true,
        notAllowed: false,
        project: {
          project: {},
          project_statuses: [],
          ats_data: {},
          address: {},
          users: [],
          gpr_report: {},
          locations: [],
          ats_company: {},
        },
      }
    },
    computed: {},
    methods: {
      selectTab(tab) {
        if (tab !== this.currentTab) {
          this.currentTab = tab;
        }
      },
      deleteCommentFromProject(comment_id){
        this.project.comments = this.project.comments.filter((m) => m.id !== comment_id);

      },
      goSignature(num){
        console.log('goSignature', num)
      },
    },
    created() {
     var projectId = this.$route.params.id;
     if (projectId == undefined) {
       this.$router.push("projectportal");
     } else {
       api.getProject(projectId).then((response) => {
         this.project = idx(response, _ => _.data);
         this.isLoading = false;
         var cu = this.$store.state.user
         var co = this.$store.state.company
         var cu_in_pu = this.project.users.filter((a) => a.id == cu.id)
         if (cu.gpr_access == true || cu.email == this.project.project_manager.email || cu_in_pu.length || co.id == this.project.ats_company.id){
           this.notAllowed = false;
         }

        this.request.signed_company_name = idx(response, _ => _.data.ats_company.name);
        this.request.signed_user_name = idx(response, _ => _.data.site_contact.name);
        this.request.gpr_techinician = idx(response, _ => _.data.ats_data.signed_user_name);
        this.request.customer_signature = idx(response, _ => _.data.ats_data.customer_signature);

       }).catch((e) => {
         console.log(e)
       });
     }

    },
    filters: {
      formatDate: function (value) {
        if (value) {
          return moment(String(value)).format('MM/DD/YYYY')
        }
      }
    }

  };
</script>
<style lang="scss">
 @media only screen and (max-width: 1200px){
    .md-layout {
      width: 90% !important;
    }
    .md-card-tabs .md-list .md-list-item .md-list-item-button .md-list-item-content{
      padding: 10px 5px;
    }
  }
  @media only screen and (max-width: 600px){
    .md-layout {
      width: 100%;
    }
    .tab-pane-1 .smbox{
      width: 100%;
    }
  }
  .not-allowed {
    text-align: center;
  }


</style>

<!-- <template slot="tab-pane-2">
    <LocationsTab
    v-bind:ats_data="project.ats_data"
    v-bind:locations="project.locations"
    v-bind:projectId="project.project.id"
    v-bind:gpr_report="project.gpr_report"
    />
</template> -->
